export { QRSideBar as default } from './QRSideBar'
